/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Meta_ThinkingInputs */

const es_chat_meta_thinking = /** @type {(inputs: Chat_Meta_ThinkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pensando`)
};

const en_chat_meta_thinking = /** @type {(inputs: Chat_Meta_ThinkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thinking`)
};

/**
* | output |
* | --- |
* | "Thinking" |
*
* @param {Chat_Meta_ThinkingInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_meta_thinking = /** @type {((inputs?: Chat_Meta_ThinkingInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Meta_ThinkingInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_meta_thinking(inputs)
	return en_chat_meta_thinking(inputs)
});
export { chat_meta_thinking as "chat.meta.thinking" }